import { useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { IconButton, Tooltip, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ThumbUpOffAlt as ThumbUpOffAltIcon } from '@mui/icons-material';
import { useGetProfileQuery } from '../features/api/rest/apiProfileSlice';
import { useGetReviewVoteQuery, useUpdateReviewVoteMutation } from '../features/api/rest/apiVoting';

function VotingReview({ id, totScore, numVotes }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { ean } = useParams();
  const [totPos, setTotPos] = useState((totScore + numVotes) / 2);

  const [updateReviewVote, { isUpdating }] = useUpdateReviewVoteMutation();

  const { status } = useGetProfileQuery(undefined, { refetchOnMountOrArgChange: true });
  const { vote } = useGetReviewVoteQuery(
    { ean, id },
    {
      selectFromResult: ({ data }) => ({
        vote: data?.vote,
      }),
    }
  );

  const handleVoteClick = async (type) => {
    if (status === 'fulfilled') handleNewVote(type);
    else navigate('/login', { state: { next: `${location.pathname}${location.search}` } });
  };

  const handleNewVote = async (type) => {
    if (type === vote) {
      try {
        await updateReviewVote({ payload: { vote: 'CLEAR' }, ean, id }).unwrap();
        setTotPos(totPos - 1);
      } catch (err) {
        throw new Error(err);
      }
    } else {
      try {
        await updateReviewVote({ payload: { vote: type }, ean, id }).unwrap();
        setTotPos(totPos + 1);
      } catch (err) {
        throw new Error(err);
      }
    }
  };

  return (
    <Tooltip title={t('reviews.votes.up')}>
      <IconButton onClick={() => handleVoteClick('UP')} disabled={isUpdating}>
        <ThumbUpOffAltIcon sx={{ color: vote === 'UP' ? 'info.main' : 'grey.500' }} />
        <Typography variant="body2" color={vote === 'UP' ? 'info.main' : 'grey.500'} sx={{ position: 'absolute', top: -5, right: -5, fontSize: 12 }}>
          {totPos}
        </Typography>
      </IconButton>
    </Tooltip>
  );
}

VotingReview.propTypes = {
  id: PropTypes.number.isRequired,
  totScore: PropTypes.number.isRequired,
  numVotes: PropTypes.number.isRequired,
};

export default VotingReview;
